import React from 'react';
import Modal from '@/components/ui/Modal';
import EditCourseForm from './EditCourseForm';
import { Course } from '../types';

interface EditCourseModalProps {
  course: Course;
  isOpen: boolean;
  onClose: () => void;
}

const EditCourseModal: React.FC<EditCourseModalProps> = ({ course, isOpen, onClose }) => {
  const handleFormSuccess = () => {
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Edit Course"
      maxWidth="lg"
    >
      <EditCourseForm course={course} onSuccess={handleFormSuccess} />
    </Modal>
  );
};

export default EditCourseModal; 